const CAROUSEL_ITEMS = [
  {
    id: 1,
    title: '香蕉视频年度巨献 · 国风大剧特辑',
    desc: '精选香蕉视频平台年度重磅古装国风大剧，服化道精湛剧情考究，从盛唐风华到明清传奇，带你领略中华传统文化的视觉盛宴。',
    label: '年度企划',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20composition%20featuring%20warm%20golden%20hour%20lighting%20over%20abstract%20geometric%20patterns%20inspired%20by%20film%20frames%2C%20elegant%20entertainment%20platform%20atmosphere%2C%20sophisticated%20modern%20aesthetic%20with%20rose%20gold%20and%20amber%20tones%2C%20soft%20atmospheric%20texture&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '糖豆视频 · 烧脑悬疑月专题',
    desc: '糖豆视频高分悬疑剧集月度专题，从心理犯罪到社会派推理，层层反转挑战智商，玫瑰视频为你一站式收集全系列好剧。',
    label: '月度专题',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20widescreen%20cinematic%20scene%20with%20warm%20sunset%20amber%20lighting%2C%20abstract%20film%20strip%20patterns%2C%20elegant%20composition%2C%20modern%20entertainment%20visual%2C%20sophisticated%20warm%20tones%20with%20subtle%20rose%20gold%20accents&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '小蓝视频 × 蓝莓视频 · 高分电影周',
    desc: '两大平台高分电影联合展映，从豆瓣8.5+口碑佳作到国际电影节获奖影片，精选百部好片陪你度过每一个电影之夜。',
    label: '联合展映',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20cinematic%20wide%20composition%20with%20warm%20amber%20and%20rose%20lighting%2C%20flowing%20abstract%20patterns%20reminiscent%20of%20streaming%20media%2C%20modern%20sophisticated%20aesthetic%2C%20elegant%20entertainment%20atmosphere%2C%20soft%20focus%20texture&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '玫瑰视频独家 · 不缓冲观影节',
    desc: '玫瑰视频专属观影活动，精选高清不缓冲专区全量资源限时开放，配合最新播放技术升级，体验前所未有的流畅追剧快感。',
    label: '独家活动',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20widescreen%20cinematic%20composition%20with%20dramatic%20warm%20lighting%2C%20abstract%20geometric%20film%20reel%20patterns%2C%20sophisticated%20modern%20entertainment%20visual%2C%20rich%20amber%20and%20rose%20gold%20tones%2C%20atmospheric%20texture&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1300px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-3">
            特别企划
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-2">焦点专题</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            精选优质内容打造深度影视专题体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {CAROUSEL_ITEMS.map((item) => (
            <article
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-background-300/80 transition-all duration-200 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-200/50">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 rounded-full bg-background-50/90 text-xs font-medium text-primary-700">
                    {item.label}
                  </span>
                </div>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="text-base md:text-lg font-heading text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed flex-1">{item.desc}</p>
                <span className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium mt-3 whitespace-nowrap">
                  探索专题
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}